import { render, staticRenderFns } from "./MarkingsListItem.vue?vue&type=template&id=596a4e89&scoped=true"
import script from "./MarkingsListItem.vue?vue&type=script&lang=js"
export * from "./MarkingsListItem.vue?vue&type=script&lang=js"
import style0 from "./MarkingsListItem.vue?vue&type=style&index=0&id=596a4e89&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596a4e89",
  null
  
)

export default component.exports